import { teams } from "@/mocks/teams";

interface FilterBarProps {
  dates: string[];
  date: string;
  team: string;
  status: string;
  onDate: (v: string) => void;
  onTeam: (v: string) => void;
  onStatus: (v: string) => void;
  formatDate: (d: string) => string;
}

const statusOptions = [
  { value: "全部", label: "全部状态" },
  { value: "live", label: "直播中" },
  { value: "upcoming", label: "未开始" },
  { value: "finished", label: "已结束" },
];

export default function FilterBar({
  dates,
  date,
  team,
  status,
  onDate,
  onTeam,
  onStatus,
  formatDate,
}: FilterBarProps) {
  return (
    <div className="bg-background-50 rounded-lg border border-background-200 p-4 md:p-5">
      <div className="flex flex-col gap-4">
        <div>
          <span className="block text-xs font-label text-foreground-500 mb-2">比赛日期</span>
          <div className="flex gap-2 overflow-x-auto no-scrollbar pb-1">
            <button
              type="button"
              onClick={() => onDate("全部")}
              className={`px-3.5 py-2 rounded-md text-xs font-label whitespace-nowrap transition-colors cursor-pointer ${
                date === "全部" ? "bg-primary-500 text-background-50" : "bg-background-100 text-foreground-600 hover:bg-background-200"
              }`}
            >
              全部日期
            </button>
            {dates.map((d) => (
              <button
                key={d}
                type="button"
                onClick={() => onDate(d)}
                className={`px-3.5 py-2 rounded-md text-xs font-label whitespace-nowrap transition-colors cursor-pointer ${
                  date === d ? "bg-primary-500 text-background-50" : "bg-background-100 text-foreground-600 hover:bg-background-200"
                }`}
              >
                {formatDate(d)}
              </button>
            ))}
          </div>
        </div>

        <div className="flex flex-col sm:flex-row gap-3">
          <label className="flex-1">
            <span className="block text-xs font-label text-foreground-500 mb-2">选择球队</span>
            <div className="relative">
              <select
                value={team}
                onChange={(e) => onTeam(e.target.value)}
                className="w-full appearance-none bg-background-100 border border-background-300 rounded-md px-3 py-2.5 text-sm text-foreground-900 cursor-pointer focus:outline-none focus:ring-2 focus:ring-primary-400"
              >
                <option value="全部">全部球队</option>
                {teams.map((t) => (
                  <option key={t.id} value={t.id}>
                    {t.name}
                  </option>
                ))}
              </select>
              <i className="ri-arrow-down-s-line absolute right-3 top-1/2 -translate-y-1/2 text-foreground-500 pointer-events-none"></i>
            </div>
          </label>

          <label className="flex-1">
            <span className="block text-xs font-label text-foreground-500 mb-2">直播状态</span>
            <div className="relative">
              <select
                value={status}
                onChange={(e) => onStatus(e.target.value)}
                className="w-full appearance-none bg-background-100 border border-background-300 rounded-md px-3 py-2.5 text-sm text-foreground-900 cursor-pointer focus:outline-none focus:ring-2 focus:ring-primary-400"
              >
                {statusOptions.map((s) => (
                  <option key={s.value} value={s.value}>
                    {s.label}
                  </option>
                ))}
              </select>
              <i className="ri-arrow-down-s-line absolute right-3 top-1/2 -translate-y-1/2 text-foreground-500 pointer-events-none"></i>
            </div>
          </label>
        </div>
      </div>
    </div>
  );
}